// export const  = "/auth/admin/login";

export const SCHOOL_LIST = "/school-details"
export const STUDENT_LIST = "/block/get-student-list"
//beo action approve and reject
export const BEO_ACCEPT = "/block/accept/"
export const BEO_REJECT = "/block/reject/"

// block list 
export const DEO_BLOCK_LIST = "/district/get-block-list"
export const BLOCK_STUDENT_ID = "/block/get-students-details/";

//state apis end points
export const DISTRICT_LIST = "/state/get-district"
export const STATE_BLOCK_LIST = "/state/get-district/"
export const STATE_STUDENT_LIST = "/state/get-student-list/"
export const STATE_STUDENT_ID = "/state/students-details";
export const STUDENT_ROLL_BACK = "/state/cancel-block-action/"
export const STUDENT_SEARCH = "/student/get-student-id-by-application-id";

//division
export const DIVISION_DISTRICT_LIST = "/division/get-district"
export const DIVISION_STATE_BLOCK_LIST = "/division/get-district/"
export const DIVISION_STATE_STUDENT_LIST = "/division/get-student-list/"
export const DIVISION_STATE_STUDENT_ID = "/division/students-details";


//deo
export const DISTRICT_BLOCK_LIST = "district/get-blocks"
export const DISTRICT_STUDENT_LIST = "/district/get-student-list/"
export const DISTRICT_STUDENT_ID = "/district/students-details/"

//school 
export const SCHOOL_STUDENT_LIST = "/school/students"
export const SCHOOL_STUDENT_DETAILS = "/school/students-details/"
export const ADMITTED_STUDENT_SCHOOL = "/school/students-accept-new/"
export const NOT_ADMITTED_STUDENT_SCHOOL = "/school/students-reject-new/"


export const ADD_SCHOOL_DETAILS = "/school/add-school-details"
export const UPDATE_SCHOOL_DETAILS = "/school/update-school-details"
export const GET_SCHOOL_DETAILS = "/school/get-school-details"


// BEO DEO actions log 
export const BEO_DEO_ACTIONS_LOG = "/block/action-logs/";
// edit student
export const EDIT_STUDENT = "/block/edit-student";

// get list of edit request  Common for beo and deo 
export const GET_LIST_OF_EDIT_REQUEST = "/block/edit-requests";


//--------------DEO STUDENT Verification--------------------- 

// getStudentEditRequest
export const GET_STUDENT_REQUEST = "/district/student-edit-requests";
// approveStudentEditRequest
export const APPROVE_STUDENT_EDIT_REQUEST = "/district/approve-student-edit";
// rejectApproveStudentRequest 
export const REJECT_APPROVE_STUDENT_REQUEST = "/district/reject-student-edit"
// deo student actions log 
export const GET_ACTIONS_LOG_DEO = "/district/student-action-logs/";



// get list of school by state 
export const GET_SCHOOL_LIST_BY_STATE = "/state/schools";
// state school  api 
export const CREATE_SCHOOL_BY_STATE = "/state/schools/create";
// enable school by state 
export const ENABLE_SCHOOL_BY_STATE = "/state/school/enable/";
// disabled school by state with region
export const DISABLE_SCHOOL_BY_STATE = "/state/schools/";
// update school details 
export const UPDATE_SCHOOL_DETAILS_BY_STATE = "/state/schools/";

// rollback school by state 
export const ROLLBACK_SCHOOL = "/state/reject-school-details/"
// rollback student by state 
export const ROLLBACK_STUDENT = "/state/rollback-student-form/"

// --------------------- common get master session -------------
export const GET_MASTER_SESSION = "/masters/sessions";

// ---------------------- landing page contact us -------------- 
export const CONTACT_US_LANDING_PAGE = "/contact";

// ---------------------- admin: inquiry / contact management -------------- 
export const GET_CONTACT_INQUIRY_LIST = "/contact";
export const MARK_CONTACT_INQUIRY_READ = "/contact/read";